import BaseRepository from 'Domain/Repositories/BaseRepository/BaseRepository';
import { Location }   from 'Domain/Models';

const config = {
    model: Location,
    baseRoute: '/admin/location',
    singular: 'location',
    plural: 'locations',
}

class LocationRepository extends BaseRepository<Location, typeof config.singular, typeof config.plural> {

}

export default new LocationRepository(config);
